(function () {
    'use strict';

    angular
        .module(app.modules.scoring.name)
        .directive('ggWagerReportDirective', ggWagerReportDirective);

    function ggWagerReportDirective() {
        return {
            require: 'ggWagerReportDirective',
            templateUrl: 'app/scoring/directives/wager-report.html',
            scope: { roundId: '=' },
            controller: ggWagerReportDirectiveCtrl,
            replace: true,
            link: postLink,
            controllerAs: 'vm',
            bindToController: true
        }

        function postLink(scope, iElement, iAttrs, ggWagerReportDirectiveCtrl) {
            ggWagerReportDirectiveCtrl.init(iElement, iAttrs); 
        }
    }

    ggWagerReportDirectiveCtrl.$inject = ['$scope', '$timeout', '$exceptionHandler', 'wagerReportHub'];
    function ggWagerReportDirectiveCtrl($scope, $timeout, $exceptionHandler, wagerReportHub) {
        // Interface
        var vm = this;
        vm.isProcessing = false;
        vm.loaded = false;

        vm.init = init;
        vm.formatWager = formatWager;
        vm.formatHoleNumber = formatHoleNumber;

        wagerReportHub = wagerReportHub();

        // Implementation
        function init(element, attrs) {
            wagerReportHub.on('getWagerReport', onWagerReportData);
            $scope.$watch('vm.roundId', roundIdIdWatchAction);
            $scope.$on('$destroy', onDestroy);

        }
        function formatWager(amount) {
            var amt;
            if (amount) {
                amt = Math.round(amount, 0);
                if (amt < 0) {
                    amt = amt * -1;
                }
            }
            return amt;
        }
        function formatHoleNumber(n) {
            var nn = n;
            if (n == 9.1) {
                nn = "OUT";
            }
            if (n == 18.1) {
                nn = "IN";
            }
            if (n == 18.2) {
                nn = "TOT";
            }
            return nn;
        }

        // Events
        function onWagerReportData(data) {
            $timeout(function () {
                vm.data = data;
            });
        }
        function onDestroy() {
            wagerReportHub.disconnect();
        }

        // Watchers
        function roundIdIdWatchAction(newValue, oldValue) {
            vm.loaded = false;
            onWagerReportData(null);
            if (vm.roundId) {
                vm.isProcessing = true;
                wagerReportHub.getWagerReport(vm.roundId).catch(onError).finally(onLoaded);
            }
            else
                vm.loaded = true;

            function onError(error) {
                $exceptionHandler(error.message);
            }

            function onLoaded() {
                vm.loaded = true;
                vm.isProcessing = false;
            }
        }
    }
})();